export default __webpack_public_path__ + "static/media/ConsultIcon.a30333d2.svg";